<div class="container mx-auto px-0 py-0">
  <div class="bg-white shadow-md rounded-lg p-6" style="border-top: solid #6c757d 4px;">
    <div class="flex justify-between items-center mb-6">
      <div class="flex items-center space-x-2">
        <mat-icon class="w-6 h-6">settings</mat-icon>
        <h2 class="text-2xl font-bold mb-0">Stammdaten</h2>
      </div>
    </div>

    <mat-tab-group>

          <!--
              PRODUKTE
          -->
          <mat-tab label="Produkte">
            <div class="mt-6">
              <div class="flex justify-between items-center mb-4">
                <div class="flex items-center space-x-2">
                  <!-- Filter Dropdown -->
                  <div class="relative">
                    <button 
                      type="button" 
                      (click)="artikelFilterOpen = !artikelFilterOpen"
                      class="inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">
                      {{ artikelFilterStatus === 'all' ? 'Alle Status' : artikelFilterStatus === 'active' ? 'Aktiv' : 'Inaktiv' }}
                      <svg viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" class="-mr-1 h-5 w-5 text-gray-400">
                        <path d="M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd" fill-rule="evenodd"></path>
                      </svg>
                    </button>
                    <div 
                      *ngIf="artikelFilterOpen"
                      role="menu" 
                      class="absolute left-0 z-10 mt-2 w-56 origin-top-left rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                      <div role="none" class="py-1">
                        <button 
                          type="button" 
                          role="menuitem"
                          (click)="onArtikelFilterChange('all'); artikelFilterOpen = false"
                          [class.bg-gray-100]="artikelFilterStatus === 'all'"
                          [class.text-gray-900]="artikelFilterStatus === 'all'"
                          class="block w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:bg-gray-100 focus:text-gray-900 focus:outline-none">
                          Alle Status
                        </button>
                        <button 
                          type="button" 
                          role="menuitem"
                          (click)="onArtikelFilterChange('active'); artikelFilterOpen = false"
                          [class.bg-gray-100]="artikelFilterStatus === 'active'"
                          [class.text-gray-900]="artikelFilterStatus === 'active'"
                          class="block w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:bg-gray-100 focus:text-gray-900 focus:outline-none">
                          Aktiv
                        </button>
                        <button 
                          type="button" 
                          role="menuitem"
                          (click)="onArtikelFilterChange('inactive'); artikelFilterOpen = false"
                          [class.bg-gray-100]="artikelFilterStatus === 'inactive'"
                          [class.text-gray-900]="artikelFilterStatus === 'inactive'"
                          class="block w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:bg-gray-100 focus:text-gray-900 focus:outline-none">
                          Inaktiv
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <button mat-raised-button (click)="addNewArtikel()" color="primary" class="flex items-center space-x-2">
                  <mat-icon class="w-4 h-4">add</mat-icon>
                  <span>Neuanlage</span>
                </button>
              </div>
              <div class="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
                <table mat-table #tableArtikel [dataSource]="dataSourceArtikel" class="w-full">
                  <!-- Nummer Column -->
                  <ng-container matColumnDef="nummer">
                    <th mat-header-cell *matHeaderCellDef class="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Nummer</th>
                    <td mat-cell *matCellDef="let row" class="px-3 py-2 whitespace-nowrap text-sm text-gray-900">{{ row.nummer }}</td>
                  </ng-container>

                  <!-- Beschreibung Column -->
                  <ng-container matColumnDef="beschreibung">
                    <th mat-header-cell *matHeaderCellDef class="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Beschreibung</th>
                    <td mat-cell *matCellDef="let row" class="px-3 py-2 text-sm text-gray-900">{{ row.beschreibung }}</td>
                  </ng-container>

                  <!-- Art Column -->
                  <ng-container matColumnDef="art">
                    <th mat-header-cell *matHeaderCellDef class="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Art</th>
                    <td mat-cell *matCellDef="let row" class="px-3 py-2 whitespace-nowrap text-sm text-gray-900">{{ row.art }}</td>
                  </ng-container>

                  <!-- Basiseinheit Column -->
                  <ng-container matColumnDef="basiseinheit">
                    <th mat-header-cell *matHeaderCellDef class="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Basiseinheit</th>
                    <td mat-cell *matCellDef="let row" class="px-3 py-2 whitespace-nowrap text-sm text-gray-900">{{ row.basiseinheit }}</td>
                  </ng-container>

                  <!-- Code Column -->
                  <ng-container matColumnDef="code">
                    <th mat-header-cell *matHeaderCellDef class="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Code</th>
                    <td mat-cell *matCellDef="let row" class="px-3 py-2 whitespace-nowrap text-sm text-gray-900">{{ row.code }}</td>
                  </ng-container>

                  <!-- Status Column -->
                  <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef class="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
                    <td mat-cell *matCellDef="let row" class="px-3 py-2 whitespace-nowrap text-sm">
                      <span class="inline-flex items-center rounded-md px-2 py-1 text-xs font-medium ring-1 ring-inset"
                            [ngClass]="getStatusClasses(row.status_id)">
                        {{ getStatusDescription(row.status_id) }}
                      </span>
                    </td>
                  </ng-container>

                  <!-- Action Column -->
                  <ng-container matColumnDef="action">
                    <th mat-header-cell *matHeaderCellDef class="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Aktionen</th>
                    <td mat-cell *matCellDef="let row" class="px-3 py-2 whitespace-nowrap text-sm font-medium">
                      <button mat-icon-button (click)="editItem('Produkt', row)" aria-label="Edit" class="text-blue-600 hover:text-blue-900">
                        <mat-icon class="w-4 h-4">edit</mat-icon>
                      </button>
                    </td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="displayArtikel" class="bg-gray-50"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayArtikel" (dblclick)="editItem('Artikel', row)" class="hover:bg-gray-50 cursor-pointer"></tr>
                </table>
              </div>
            </div>
          </mat-tab>

          <!--
              MASSNAHMEN
          -->
          <mat-tab label="Maßnahmen">
            <div class="mt-6">
              <div class="flex justify-between items-center mb-4">
                <div class="flex items-center space-x-2">
                  <!-- Filter Dropdown -->
                  <div class="relative">
                    <button 
                      type="button" 
                      (click)="massnahmeFilterOpen = !massnahmeFilterOpen"
                      class="inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">
                      {{ massnahmeFilterStatus === 'all' ? 'Alle Status' : massnahmeFilterStatus === 'active' ? 'Aktiv' : 'Inaktiv' }}
                      <svg viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" class="-mr-1 h-5 w-5 text-gray-400">
                        <path d="M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd" fill-rule="evenodd"></path>
                      </svg>
                    </button>
                    <div 
                      *ngIf="massnahmeFilterOpen"
                      role="menu" 
                      class="absolute left-0 z-10 mt-2 w-56 origin-top-left rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                      <div role="none" class="py-1">
                        <button 
                          type="button" 
                          role="menuitem"
                          (click)="onMassnahmeFilterChange('all'); massnahmeFilterOpen = false"
                          [class.bg-gray-100]="massnahmeFilterStatus === 'all'"
                          [class.text-gray-900]="massnahmeFilterStatus === 'all'"
                          class="block w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:bg-gray-100 focus:text-gray-900 focus:outline-none">
                          Alle Status
                        </button>
                        <button 
                          type="button" 
                          role="menuitem"
                          (click)="onMassnahmeFilterChange('active'); massnahmeFilterOpen = false"
                          [class.bg-gray-100]="massnahmeFilterStatus === 'active'"
                          [class.text-gray-900]="massnahmeFilterStatus === 'active'"
                          class="block w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:bg-gray-100 focus:text-gray-900 focus:outline-none">
                          Aktiv
                        </button>
                        <button 
                          type="button" 
                          role="menuitem"
                          (click)="onMassnahmeFilterChange('inactive'); massnahmeFilterOpen = false"
                          [class.bg-gray-100]="massnahmeFilterStatus === 'inactive'"
                          [class.text-gray-900]="massnahmeFilterStatus === 'inactive'"
                          class="block w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:bg-gray-100 focus:text-gray-900 focus:outline-none">
                          Inaktiv
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <button mat-raised-button (click)="addNewMassnahme()" color="primary" class="flex items-center space-x-2">
                  <mat-icon class="w-4 h-4">add</mat-icon>
                  <span>Neuanlage</span>
                </button>
              </div>
              <div class="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
                <table mat-table #tableMassnahme [dataSource]="dataSourceMassnahme" class="w-full">
                  <!-- Beschreibung Column -->
                  <ng-container matColumnDef="beschreibung">
                    <th mat-header-cell *matHeaderCellDef class="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Beschreibung</th>
                    <td mat-cell *matCellDef="let row" class="px-3 py-2 text-sm text-gray-900">{{ row.beschreibung }}</td>
                  </ng-container>

                  <!-- Druck auf Bericht Column -->
                  <ng-container matColumnDef="druck_auf_bericht">
                    <th mat-header-cell *matHeaderCellDef class="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Druck auf Bericht</th>
                    <td mat-cell *matCellDef="let row" class="px-3 py-2 whitespace-nowrap text-sm text-gray-900">
                      <span [class]="row.druck_auf_bericht ? 'inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800' : 'inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800'">
                        {{ row.druck_auf_bericht ? 'Ja' : 'Nein' }}
                      </span>
                    </td>
                  </ng-container>

                  <!-- Foto erforderlich Column -->
                  <ng-container matColumnDef="foto_erforderlich">
                    <th mat-header-cell *matHeaderCellDef class="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Foto erforderlich</th>
                    <td mat-cell *matCellDef="let row" class="px-3 py-2 whitespace-nowrap text-sm text-gray-900">
                      <span [class]="row.foto_erforderlich ? 'inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800' : 'inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800'">
                        {{ row.foto_erforderlich ? 'Ja' : 'Nein' }}
                      </span>
                    </td>
                  </ng-container>

                  <!-- Sortierung Column -->
                  <ng-container matColumnDef="sortierung">
                    <th mat-header-cell *matHeaderCellDef class="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Sortierung</th>
                    <td mat-cell *matCellDef="let row" class="px-3 py-2 whitespace-nowrap text-sm text-gray-900">{{ row.sortierung }}</td>
                  </ng-container>

                  <!-- Status Column -->
                  <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef class="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
                    <td mat-cell *matCellDef="let row" class="px-3 py-2 whitespace-nowrap text-sm">
                      <span class="inline-flex items-center rounded-md px-2 py-1 text-xs font-medium ring-1 ring-inset"
                            [ngClass]="getStatusClasses(row.status_id)">
                        {{ getStatusDescription(row.status_id) }}
                      </span>
                    </td>
                  </ng-container>

                  <!-- Action Column -->
                  <ng-container matColumnDef="action">
                    <th mat-header-cell *matHeaderCellDef class="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Aktionen</th>
                    <td mat-cell *matCellDef="let row" class="px-3 py-2 whitespace-nowrap text-sm font-medium">
                      <button mat-icon-button (click)="editItem('Massnahme', row)" aria-label="Edit" class="text-blue-600 hover:text-blue-900">
                        <mat-icon class="w-4 h-4">edit</mat-icon>
                      </button>
                    </td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="displayMassnahme" class="bg-gray-50"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayMassnahme" (dblclick)="editItem('Massnahme', row)" class="hover:bg-gray-50 cursor-pointer"></tr>
                </table>
              </div>
            </div>
          </mat-tab>

          <!--
              MOBILE TEXTBAUSTEINE
          -->
          <mat-tab label="Mobile Textbausteine">
            <div class="mt-6">
              <div class="flex justify-between items-center mb-4">
                <div class="flex items-center space-x-2">
                  <!-- Filter Dropdown -->
                  <div class="relative">
                    <button 
                      type="button" 
                      (click)="textbausteinFilterOpen = !textbausteinFilterOpen"
                      class="inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">
                      {{ textbausteinFilterStatus === 'all' ? 'Alle Status' : textbausteinFilterStatus === 'active' ? 'Aktiv' : 'Inaktiv' }}
                      <svg viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" class="-mr-1 h-5 w-5 text-gray-400">
                        <path d="M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd" fill-rule="evenodd"></path>
                      </svg>
                    </button>
                    <div 
                      *ngIf="textbausteinFilterOpen"
                      role="menu" 
                      class="absolute left-0 z-10 mt-2 w-56 origin-top-left rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                      <div role="none" class="py-1">
                        <button 
                          type="button" 
                          role="menuitem"
                          (click)="onTextbausteinFilterChange('all'); textbausteinFilterOpen = false"
                          [class.bg-gray-100]="textbausteinFilterStatus === 'all'"
                          [class.text-gray-900]="textbausteinFilterStatus === 'all'"
                          class="block w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:bg-gray-100 focus:text-gray-900 focus:outline-none">
                          Alle Status
                        </button>
                        <button 
                          type="button" 
                          role="menuitem"
                          (click)="onTextbausteinFilterChange('active'); textbausteinFilterOpen = false"
                          [class.bg-gray-100]="textbausteinFilterStatus === 'active'"
                          [class.text-gray-900]="textbausteinFilterStatus === 'active'"
                          class="block w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:bg-gray-100 focus:text-gray-900 focus:outline-none">
                          Aktiv
                        </button>
                        <button 
                          type="button" 
                          role="menuitem"
                          (click)="onTextbausteinFilterChange('inactive'); textbausteinFilterOpen = false"
                          [class.bg-gray-100]="textbausteinFilterStatus === 'inactive'"
                          [class.text-gray-900]="textbausteinFilterStatus === 'inactive'"
                          class="block w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:bg-gray-100 focus:text-gray-900 focus:outline-none">
                          Inaktiv
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <button mat-raised-button (click)="addNewTextbaustein()" color="primary" class="flex items-center space-x-2">
                  <mat-icon class="w-4 h-4">add</mat-icon>
                  <span>Neuanlage</span>
                </button>
              </div>
              <div class="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
                <table mat-table #tableTextbaustein [dataSource]="dataSourceTextbaustein" class="w-full">
                  <!-- Schlüsselwort Column -->
                  <ng-container matColumnDef="schluesselwort">
                    <th mat-header-cell *matHeaderCellDef class="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Schlüsselwort</th>
                    <td mat-cell *matCellDef="let row" class="px-3 py-2 whitespace-nowrap text-sm font-medium text-gray-900">{{ row.schluesselwort }}</td>
                  </ng-container>

                  <!-- Text Column -->
                  <ng-container matColumnDef="text">
                    <th mat-header-cell *matHeaderCellDef class="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Text</th>
                    <td mat-cell *matCellDef="let row" class="px-3 py-2 text-sm text-gray-900">{{ row.text }}</td>
                  </ng-container>

                  <!-- Sortierung Column -->
                  <ng-container matColumnDef="sortierung">
                    <th mat-header-cell *matHeaderCellDef class="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Sortierung</th>
                    <td mat-cell *matCellDef="let row" class="px-3 py-2 whitespace-nowrap text-sm text-gray-900">{{ row.sortierung }}</td>
                  </ng-container>

                  <!-- Status Column -->
                  <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef class="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
                    <td mat-cell *matCellDef="let row" class="px-3 py-2 whitespace-nowrap text-sm">
                      <span class="inline-flex items-center rounded-md px-2 py-1 text-xs font-medium ring-1 ring-inset"
                            [ngClass]="getStatusClasses(row.status_id)">
                        {{ getStatusDescription(row.status_id) }}
                      </span>
                    </td>
                  </ng-container>

                  <!-- Action Column -->
                  <ng-container matColumnDef="action">
                    <th mat-header-cell *matHeaderCellDef class="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Aktionen</th>
                    <td mat-cell *matCellDef="let row" class="px-3 py-2 whitespace-nowrap text-sm font-medium">
                      <button mat-icon-button (click)="editItem('Textbaustein', row)" aria-label="Edit" class="text-blue-600 hover:text-blue-900">
                        <mat-icon class="w-4 h-4">edit</mat-icon>
                      </button>
                      <button mat-icon-button (click)="removeItem('Textbaustein', row)" aria-label="Delete" class="text-red-600 hover:text-red-900">
                        <mat-icon class="w-4 h-4">delete</mat-icon>
                      </button>
                    </td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="displayTextbaustein" class="bg-gray-50"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayTextbaustein" (dblclick)="editItem('Textbaustein', row)" class="hover:bg-gray-50 cursor-pointer"></tr>
                </table>
              </div>
            </div>
          </mat-tab>

    </mat-tab-group>
  </div>
</div>